import { Box } from "@mui/material";
import SortableList, { SortableItem } from "react-easy-sort";
import { useNavigate } from "react-router-dom";

import { useFaqOrderingLogic } from "./useFaqOrderingLogic";
import { StyledDrag } from "./styled";

const FaqOrdering = () => {
  const navigate = useNavigate();
  const { faqList, onSortEnd } = useFaqOrderingLogic()

  return (
    <Box>
      <Box
        sx={{ mb: 5, cursor: 'pointer' }}
        onClick={() => {
          navigate(-1)
        }}
      >
        Go Back
      </Box>

      <SortableList
        onSortEnd={onSortEnd}
        lockAxis="y"
        draggedItemClassName="dragged"
      >
        {
          faqList.map((item, index) => {
            return (
              <SortableItem key={item.id}>
                <StyledDrag sx={{ border: '1px solid #e7e7e7' }}>
                  <p>{index + 1}</p>
                  <Box
                    display="flex"
                    flexDirection="column"
                    sx={{ cursor: 'grab', width: 500 }}
                  >

                    {item.questionAm}
                  </Box>
                </StyledDrag>
              </SortableItem>
            )
          })
        }
      </SortableList>
    </Box>
  )
};

export default FaqOrdering;
